import { gql } from '@apollo/client';

export const GET_ANALYTICS_TREE_TEST = gql`
  query Analytics($projectId: ID!, $segmentId: ID) {
    analytics(projectId: $projectId, segmentId: $segmentId) {
      treeTestResults(projectId: $projectId, segmentId: $segmentId) {
        id
        totalSuccess
        directness
        tasks {
          taskTitle
          label
          id
          directSuccess {
            total
            percentage
          }
          directFailure {
            total
            percentage
          }
          indirectSuccess {
            total
            percentage
          }
          indirectFailure {
            total
            percentage
          }
        }
      }
    }
  }
`;

export const GET_ANALYTICS_TREE_TEST_TASK_SUCCESS = gql`
  query Analytics($projectId: ID!, $segmentId: ID) {
    analytics(projectId: $projectId, segmentId: $segmentId) {
      treeTestTaskSuccess(projectId: $projectId, segmentId: $segmentId) {
        id
        label
        correctPath
        statistics {
          label
          id
          directSuccess {
            total
            percentage
          }
          directFailure {
            total
            percentage
          }
          indirectSuccess {
            total
            percentage
          }
          indirectFailure {
            total
            percentage
          }
        }
        tasks {
          id
          label
          questionType
          leftLabel
          rightLabel
          questionOrder
          total
          options {
            id
            label
            order
            count
            imageUrl
          }
          writtenAnswers {
            firstName
            valueText
            testerId
          }
        }
      }
    }
  }
`;

export const TEST_SESSION_ANSWERS_BY_PROJECT_ID = gql`
  query TestSessionAnswers($projectId: ID!) {
    testSessionAnswers(projectId: $projectId) {
        id
        question {
          id
          label
          questionOrder
        }
        treeTestPath
        treeTestResult
      }
    }
`;

export const GET_FIRST_CLICK_ANALYTICS = gql`
  query Analytics($projectId: ID!, $segmentId: ID) {
    analytics(projectId: $projectId, segmentId: $segmentId) {
      treeTestFirstClick(projectId: $projectId, segmentId: $segmentId) {
        id
        title
        description
        branches {
          id
          label
          firstClickPercentage
          visitedPercentage
        }
      }
    }
  }
`;

export const GET_PARTICIPANT_PATHS = gql`
  query Analytics($projectId: ID!, $segmentId: ID) {
    analytics(projectId: $projectId, segmentId: $segmentId) {
      treeTestParticipantPaths(projectId: $projectId, segmentId: $segmentId) {
        id
        title
        testers {
          firstName
          treeTestPath
          treeTestResult
        }
      }
    }
  }
`;
